/**
 * Pure helpers for the cart "add more convention products" upsell.
 *
 * A cart line that was added from a convention carries a `conventionId` and an
 * embedded product `object` (which holds the convention's `customer`). These
 * helpers derive the convention context from the cart and decide which member
 * products to offer as optional add-ons.
 */

/**
 * Find the convention context for the cart, based on the first cart line that
 * was added from a convention.
 *
 * @param {Array} cart - userStore.user.cart
 * @returns {{ conventionId: number, customer: number }} zeroes when the cart
 *          has no convention line.
 */
export function deriveCartConvention(cart = []) {
    const line = (cart || []).find(c => c && c.conventionId > 0);
    if (!line) {
        return { conventionId: 0, customer: 0 };
    }
    return {
        conventionId: line.conventionId,
        customer: line.object?.customer || 0,
    };
}

/**
 * Filter member products down to the ones NOT already in the cart, so the
 * add-on row only shows things the user hasn't bought yet.
 *
 * @param {Array} products - member products loaded for the convention's customer
 * @param {Array} cart - userStore.user.cart
 * @returns {Array} products whose id is not present on any cart line
 */
export function filterAddonProducts(products = [], cart = []) {
    const cartProductIds = new Set((cart || []).map(c => c && c.product));
    return (products || []).filter(p => p && !cartProductIds.has(p.id));
}
